import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgToolbarMove = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 14,
	viewBox: "0 0 12 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M2.53846 13.3077L1 1L11 7.15385C10.1026 7.15385 6.53846 7.30769 5.61538 7.92308C4.69231 8.53846 2.92308 12.0256 2.53846 13.3077Z",
		stroke: "white",
		strokeLinejoin: "round"
	})]
});
export default SvgToolbarMove;
